import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import cx from 'classnames';
import {
    STROLLER_DETAIL_VARIANT_SHOW_OPTIONS,
    STROLLER_DETAIL_VARIANT_UNAVAILABLE,
    STROLLER_DETAIL_VARIANTS_HEADING,
} from 'mk/autogenerated/translations/StrollerVariantConfigurator.5f759710717049407bd9a369f3bf1145'
import assetUrl from 'mk/common/assetUrl';
import { XMLImportItemEntity } from 'mk2/apps/bazaar/schemas';
import { strollerSingleVariant } from 'mk2/apps/strollers/constants';
import { FEATURES_LIST } from 'mk2/apps/strollers/features';
import { FEATURE_LABEL_MESSAGES } from 'mk2/apps/strollers/features/constants';
import { ListFeature } from 'mk2/apps/strollers/features/options';
import {
    StrollerEntity,
    StrollerPatternEntity,
    StrollerPhoto,
    StrollerVariantEntity,
    UserConfigurationEntity,
    VariantsOptionsEntity,
    VariantOptionValuesEntity,
} from 'mk2/apps/strollers/schemas';
import { Btn, BtnType } from 'mk2/components/Btn';
import { HorizontalScrolling } from 'mk2/components/HorizontalScrolling';
import { Img } from 'mk2/components/Img';
import { ImgCropped, ImgCropMode } from 'mk2/components/ImgCropped';
import useEventCallback from 'mk2/hooks/useEventCallback';
import React, { useEffect, useRef, useState } from 'react';
import styles from './StrollerVariantConfigurator.mscss';

interface OwnProps {
    stroller: StrollerEntity;
    strollerPhotosMap: Record<number, StrollerPhoto>;
    variants: StrollerVariantEntity[];
    currentVariantId: number;
    variantsOptions: VariantsOptionsEntity;
    eshopProducts: XMLImportItemEntity[];
    patterns: StrollerPatternEntity[];
    hasEshopWidget: boolean;
    onChangeVariantFeatureValue(slug: string, configFeatureName: string, value: string, linkedId: number);
    changeVariant(id: number);
}

interface State {
    client: boolean;
    userConfiguration: UserConfigurationEntity;
}

export class StrollerVariantConfigurator extends React.Component<OwnProps, State> {
    public static defaultProps: Partial<OwnProps> = {};

    public state: State = {
        client: false,
        userConfiguration: {},
    };

    public componentDidMount() {
        this.setState({
            client: true,
        });
    }

    addToConfiguration = (name, value) => {
        let n = this.state.userConfiguration;
        delete n[name];
        n = {[name]: value, ...n};
        this.setState({userConfiguration: n});
    };


    public render() {
        const {
            stroller,
            strollerPhotosMap,
            patterns,
            variantsOptions,
            currentVariantId,
            variants,
            eshopProducts,
            hasEshopWidget,
            changeVariant,
            onChangeVariantFeatureValue} = this.props;

        const opts = variantsOptions[currentVariantId];

        stroller.configurablesOrder.sort((a, b) => {
            if (!opts || !opts[a] || !opts[b]) {
                return 0;
            }
            const countA = opts[a].options.filter((obj) => obj.isAvailable).length;
            const countB = opts[b].options.filter((obj) => obj.isAvailable).length;
            if (countA >= 2 && countB < 2) {
              return -1;
            }
            return 0;
        });

        if (!!opts) {
            return(
            <div className={cx(styles.StrollerVariantConfigurator, hasEshopWidget && styles.StrollerVariantConfigurator__hasEshopWidget)}>
                { !strollerSingleVariant(stroller) ? <h2 className={styles.StrollerVariantConfigurator__headline}>{STROLLER_DETAIL_VARIANTS_HEADING}</h2> : null }
                <div className={styles.StrollerVariantConfigurator__fields}>
                    {stroller.configurablesOrder
                        .map((key) => (
                            <ConfigurableFeature
                                key={key}
                                stroller={stroller}
                                strollerPhotosMap={strollerPhotosMap}
                                configFeatureName={key}
                                featureName={opts[key].featureName}
                                opts={opts[key].options}
                                patterns={patterns}
                                variants={variants}
                                currentVariantId={currentVariantId}
                                eshopProducts={eshopProducts}
                                userConfiguration={this.state.userConfiguration}
                                onChangeVariantFeatureValue={onChangeVariantFeatureValue}
                                changeVariant={changeVariant}
                                addToConfiguration={this.addToConfiguration}
                            />
                        ))}
                </div>
            </div>
            );
        } else {
            return(
            <></>
            );
        }
    }
}

interface ConfigurableFeatureOwnProps {
    stroller: StrollerEntity;
    strollerPhotosMap: Record<number, StrollerPhoto>;
    configFeatureName: string;
    featureName: string;
    opts: VariantOptionValuesEntity[];
    patterns: StrollerPatternEntity[];
    variants: StrollerVariantEntity[];
    currentVariantId: number;
    eshopProducts: XMLImportItemEntity[];
    userConfiguration: UserConfigurationEntity;
    onChangeVariantFeatureValue(slug: string, configFeatureName: string, value: string, linkedId: number);
    changeVariant(id: number);
    addToConfiguration(name: string, value: string);
}

function niceValueLabel(featureClass, optionLabel) {
    return featureClass?.OPTIONS?.[optionLabel] || optionLabel;
}

const ConfigurableFeature: React.FunctionComponent<ConfigurableFeatureOwnProps> = ({
    stroller,
    strollerPhotosMap,
    configFeatureName,
    featureName ,
    opts,
    patterns,
    variants,
    currentVariantId,
    eshopProducts,
    userConfiguration,
    onChangeVariantFeatureValue,
    changeVariant,
    addToConfiguration,
}) => {

    // const count = opts.filter((obj) => obj.isAvailable).length;
    // const [showOptions, setShowOptions] = useState<boolean>(count >= 2);
    const [showOptions, setShowOptions] = useState<boolean>(configFeatureName === 'config_color');
    const onToggleShowOptions = useEventCallback(() => {
            setShowOptions(!showOptions);
        },
        [setShowOptions],
    );

    const selected = opts.filter((obj) => obj.selected);
    const selectedValue = selected.length > 0 ? 'label' in selected[0] ? selected[0].label : selected[0].value : null;
    let hasAnyOptionPhoto = false;
    opts.map(opt => {
        if (!!opt.optionPhoto) {
            hasAnyOptionPhoto = true;
        }
    });

    return (
        <div className={!strollerSingleVariant(stroller) ? styles.ConfigurableFeature : styles.SingleConfigurableFeature }>
            <div className={!strollerSingleVariant(stroller) ? styles.ConfigurableFeature__header : null}>
                <div>
                    <span className={styles.ConfigurableFeature__header__variantColorSample}>{FEATURE_LABEL_MESSAGES[featureName] || featureName}:
                        <span className={styles.ConfigurableFeature__header__currentValue}>{niceValueLabel(FEATURES_LIST[featureName], selectedValue)}</span>
                        {strollerSingleVariant(stroller) ?
                        <div className={styles.ConfigurableFeature__header__color}>
                            {opts[0].pattern &&
                                getPattern(opts[0].pattern, patterns)
                            }

                            {opts[0].color &&
                                getColorWheel(opts[0].color)
                            }
                            {!opts[0].isAvailable &&
                                <svg>
                                    <line x1="0" y1="0" x2="100%" y2="100%" />
                                </svg>}
                        </div> : null
                        }
                    </span>
                </div>
                    {!strollerSingleVariant(stroller) ?
                        <Btn
                            icon={showOptions ? faChevronUp : faChevronDown}
                            type={BtnType.Link}
                            onClick={onToggleShowOptions}
                        /> : null
                    }
            </div>
            {showOptions &&
                <div className={styles.ConfigurableFeature__values}>
                    <HorizontalScrolling>
                        {opts.map((option, idx) => {
                            if (!option.disabled) {
                                return (
                                    <ConfigurableFeatureValue
                                        key={idx}
                                        stroller={stroller}
                                        strollerPhotosMap={strollerPhotosMap}
                                        configFeatureName={configFeatureName}
                                        featureClass={FEATURES_LIST[featureName]}
                                        variants={variants}
                                        currentVariantId={currentVariantId}
                                        eshopProducts={eshopProducts}
                                        option={option}
                                        selected={option.selected}
                                        patterns={patterns}
                                        userConfiguration={userConfiguration}
                                        onChangeVariantFeatureValue={onChangeVariantFeatureValue}
                                        onToggleShowOptions={onToggleShowOptions}
                                        changeVariant={changeVariant}
                                        addToConfiguration={addToConfiguration}
                                        hasAnyOptionPhoto={hasAnyOptionPhoto}
                                    />
                                );
                            } else {
                                return(
                                    <div key={idx} className={styles.ConfigurableFeature__disabled}>
                                        <ConfigurableFeatureValue
                                                stroller={stroller}
                                                strollerPhotosMap={strollerPhotosMap}
                                                configFeatureName={configFeatureName}
                                                featureClass={FEATURES_LIST[featureName]}
                                                variants={variants}
                                                currentVariantId={currentVariantId}
                                                eshopProducts={eshopProducts}
                                                option={option}
                                                selected={false}
                                                patterns={patterns}
                                                userConfiguration={userConfiguration}
                                                onChangeVariantFeatureValue={onChangeVariantFeatureValue}
                                                onToggleShowOptions={onToggleShowOptions}
                                                changeVariant={changeVariant}
                                                addToConfiguration={addToConfiguration}
                                                hasAnyOptionPhoto={hasAnyOptionPhoto}
                                            />
                                    </div>
                                );
                            }
                        })}
                    </HorizontalScrolling>
                </div>
            }
        </div>
    );
};

ConfigurableFeature.displayName = 'ConfigurableFeature';

interface ConfigurableFeatureValueOwnProps {
    stroller: StrollerEntity;
    strollerPhotosMap: Record<number, StrollerPhoto>;
    configFeatureName: string;
    featureClass?: ListFeature;
    option: VariantOptionValuesEntity;
    variants: StrollerVariantEntity[];
    currentVariantId: number;
    eshopProducts: XMLImportItemEntity[];
    selected: boolean;
    patterns: StrollerPatternEntity[];
    userConfiguration: UserConfigurationEntity;
    hasAnyOptionPhoto: boolean;

    onChangeVariantFeatureValue(slug: string, configFeatureName: string, value: string, linkedId: number);
    changeVariant(id: number);
    onToggleShowOptions();
    addToConfiguration(name: string, value: string);
}

function getColorWheel(colorStr) {
    const color = colorStr.split(',');

    if (color.length === 1) {
        return (<div
            className={styles.ConfigurableFeatureValue__color}
            style={{ backgroundColor: `#${color[0]}` }}
        />);
    } else if (color.length === 2) {
        return (
            <div
                className={styles.ConfigurableFeatureValue__color}
                style={{ background: `linear-gradient(to left, #${color[0]} 0%,#${color[0]} 50%,#${color[1]} 51%,#${color[1]} 100%)` }}
            />);
    } else if (color.length === 3) {
        return (<div
                className={styles.ConfigurableFeatureValue__color}
                style={{ background: `linear-gradient(to left, #${color[0]} 0%,#${color[0]} 33%,#${color[1]} 34%,#${color[1]} 66%,#${color[2]} 67%,#${color[2]} 100%)` }}
            />);
    }
}
function getPattern(patternCode, patterns) {
    const pattern = patterns.find((obj) => {
        return obj.code === patternCode;
    });
    if (pattern === null) {
        return null;
    }
    return(
        <ImgCropped
            photo={pattern.patternImage}
            photoVersion={'s150x150'}
            width={24}
            height={8}
            mode={ImgCropMode.Cover}
            className={styles.ConfigurableFeatureValue__color}
        />
    );
}

const ConfigurableFeatureValue: React.FunctionComponent<ConfigurableFeatureValueOwnProps> = ({
    stroller,
    strollerPhotosMap,
    configFeatureName,
    featureClass,
    option,
    variants,
    currentVariantId,
    eshopProducts,
    patterns,
    selected,
    userConfiguration,
    onChangeVariantFeatureValue,
    changeVariant,
    addToConfiguration,
    hasAnyOptionPhoto,
}) => {

    const onClickCallback = useEventCallback(
        () => {
            let id = option.linkedId;
            addToConfiguration(configFeatureName, option.value);

            if (!id) {
                let vars = variants.filter(v => {
                    const color = v.features[configFeatureName].color;
                    const pattern = v.features[configFeatureName].pattern;
                    if (!!color) {
                        return  color === option.value;
                    }
                    if (!!pattern) {
                        return  pattern === option.value;
                    }
                    return  v.features[configFeatureName] === option.value;
                });
                stroller.configurablesOrder.map((name) => {
                    const filtered = vars.filter(v => {
                        const color = v.features[name].color;
                        const pattern = v.features[name].pattern;
                        if (!!color) {
                            return  color === userConfiguration[name];
                        }
                        if (!!pattern) {
                            return  pattern === userConfiguration[name];
                        }
                        return v.features[name] === userConfiguration[name];
                    });
                    if (filtered.length > 0) {
                        vars = filtered;
                    }
                });
                if (vars.length > 0) {
                    id = vars[0].id;
                }
            }

            if (!!id) {
                changeVariant(id);
                const regex = new RegExp(/\/[0-9]+\//);
                if (regex.test(location.pathname)) {
                    history.replaceState({}, null, location.pathname.replace(regex, `/${id}/`));
                } else {
                    history.replaceState({}, null, location.pathname + `${id}/`);
                }
                    }
                },
                [stroller, configFeatureName, option, onChangeVariantFeatureValue],
        );

    const variantPhoto = !!stroller && !!option.optionPhoto ? strollerPhotosMap[option.optionPhoto] : null;
    const nullPhoto = assetUrl + 'img/general/null-img.svg';

    const currentPrice = eshopProducts.find(e => e.strollerVariant.id === currentVariantId)?.current?.price;
    const newPrice = eshopProducts.find(e => e.strollerVariant.id === option.linkedId)?.current?.price;
    const priceDiff = !!currentPrice && !! newPrice ? (newPrice - currentPrice) : 0;
    const priceInfo = priceDiff === 0 ? <div>&nbsp;</div> : priceDiff > 0 ? `+${priceDiff.toFixed(2)}€` : `${priceDiff.toFixed(2)}€`;
    const text = !option.isAvailable ? STROLLER_DETAIL_VARIANT_UNAVAILABLE : option.disabled ? STROLLER_DETAIL_VARIANT_SHOW_OPTIONS : priceInfo;

    const inputRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        const element = inputRef?.current;
        if (option.selected) {
            if (!!element) {
                const positionY = window.scrollY;
                const positionX = window.scrollX;
                element.scrollIntoView();
                window.scrollTo(positionX, positionY);
            }
        }
    }, [option]);

    return (
        <div
            style={{border: selected ? '2px solid #F7AE39' : '1px solid #909EA8'}}
            onClick={onClickCallback}
            className={cx(styles.ConfigurableFeatureValue,
                          option.disabled && styles.ConfigurableFeatureValue__crossed)}
            ref={inputRef}
        >
            {(configFeatureName === 'config_color' || hasAnyOptionPhoto) && (
                <div className={styles.ConfigurableFeatureValue__img}>
                    {variantPhoto ? (
                        <ImgCropped
                        imgUrl={variantPhoto.url720x720}
                        lazy={false}
                        imgWidth={variantPhoto.originalWidth}
                        imgHeight={variantPhoto.originalHeight}
                        mode={ImgCropMode.Embed}
                        width={100}
                        height={100}
                    />
                    ) :
                        (<Img
                        src={nullPhoto}
                        lazy={false}
                        width={100}
                        height={100}
                    />
                        )}
                </div>
            )}
            <div className={styles.ConfigurableFeatureValue__label}>
                {niceValueLabel(featureClass, option.label)}
            </div>

            <div className={styles.ConfigurableFeatureValue__details}>
                {option.pattern &&
                    getPattern(option.pattern, patterns)
                }

                {option.color &&
                    getColorWheel(option.color)
                }

                <div className={styles.ConfigurableFeatureValue__change}>
                    {text}
                </div>

                {!option.isAvailable &&
                    <svg>
                        <line x1="0" y1="0" x2="100%" y2="100%" />
                    </svg>}
            </div>
        </div>
    );
};

ConfigurableFeatureValue.displayName = 'ConfigurableFeatureValue';
